// extracted by mini-css-extract-plugin
export var closeButton = "_k1-1";
export var closeX = "_k1-3";
export var container = "_k1-0";
export var image = "_k1-2";